// Per-user display preferences (set from the signed-in user's prefs) and helpers that read them.
let tz = "Europe/Athens";
let oddsFormat = "decimal";

export function applyPrefs(prefs) {
  tz = prefs?.timezone || "Europe/Athens";
  oddsFormat = "decimal";  // NBACUBE always shows European (decimal) odds
}

export const displayTz = () => tz;

function fraction(x) {
  let best = [Math.round(x), 1];
  for (let d = 1; d <= 100; d += 1) {
    const n = Math.round(x * d);
    if (Math.abs(n / d - x) < Math.abs(best[0] / best[1] - x) - 1e-9) best = [n, d];
    if (Math.abs(n / d - x) < 0.005) break;
  }
  return `${best[0]}/${best[1]}`;
}

export function oddsText(decimal, format = oddsFormat) {
  if (decimal == null) return "—";
  if (format === "american") return decimal >= 2 ? `+${Math.round((decimal - 1) * 100)}` : `${Math.round(-100 / (decimal - 1))}`;
  if (format === "fractional") return fraction(decimal - 1);
  return Number(decimal).toFixed(2);
}

// Backend-relative asset paths (e.g. uploaded avatars) need the API host.
export const assetUrl = (url) => (url && url.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url);
